import type { AIUploadQuestionData } from '../questionNormalizer';
import styles from './AIUploadInstructorView.module.css';

interface AIUploadInstructorViewProps {
  question: AIUploadQuestionData;
}

function formatPoints(value: number) {
  return Number.isInteger(value) ? String(value) : value.toFixed(2).replace(/\.?0+$/, '');
}

export function AIUploadInstructorView({ question }: AIUploadInstructorViewProps) {
  return (
    <section className={styles.root} aria-label="AI Upload instructor details">
      <p className={styles.note}>Students will upload their work to be graded by KAI.</p>
      <div className={styles.header}>
        <h4 className={styles.title}>Grading rubric</h4>
        <span className={styles.total}>
          {formatPoints(question.gradingRubric.totalScore)} pts
        </span>
      </div>
      <ol className={styles.list}>
        {question.gradingRubric.rubricUnits.map((unit) => (
          <li className={styles.item} key={unit.id}>
            <div className={styles.itemHeader}>
              <span className={styles.name}>{unit.name}</span>
              <span className={styles.points}>{formatPoints(unit.score)} pts</span>
            </div>
            {unit.details ? (
              <p className={styles.details}>{unit.details}</p>
            ) : null}
          </li>
        ))}
      </ol>
    </section>
  );
}
